// src/contexts/ArticleContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const ArticleContext = createContext();

export const useArticles = () => {
  const context = useContext(ArticleContext);
  if (!context) {
    throw new Error('useArticles必须在ArticleProvider内使用');
  }
  return context;
};

export const ArticleProvider = ({ children }) => {
  // 从localStorage加载初始文章数据
  const loadInitialArticles = () => {
    try {
      const savedArticles = localStorage.getItem('blog_articles');
      if (savedArticles) {
        return JSON.parse(savedArticles);
      }
    } catch (error) {
      console.error('加载文章数据失败:', error);
    }
    
    // 默认文章数据
    return [
      {
        id: 1,
        title: 'React Hooks最佳实践与性能优化指南',
        excerpt: '本文将深入探讨React Hooks的高级用法，包括自定义Hooks的设计模式、性能优化技巧以及常见陷阱的避免方法。',
        content: `# React Hooks最佳实践与性能优化指南

## 介绍
React Hooks是React 16.8引入的新特性，它让函数组件拥有了状态管理和生命周期等能力。`,
        date: '2024-01-15',
        tags: ['React', 'Hooks', '性能优化'],
        author: '管理员',
        authorId: 1,
        category: '前端',
        views: 124,
        likes: 45,
        comments: 12
      },
      {
        id: 2,
        title: 'TypeScript在现代前端开发中的应用',
        excerpt: 'TypeScript如何帮助我们在大型项目中保持代码质量和开发效率？本文将分享TypeScript的高级类型技巧和项目配置经验。',
        content: `# TypeScript在现代前端开发中的应用

## 为什么选择TypeScript
TypeScript是JavaScript的超集，为大型项目开发提供了更好的工具支持。`,
        date: '2024-01-10',
        tags: ['TypeScript', '前端', '开发工具'],
        author: '管理员',
        authorId: 1,
        category: '前端',
        views: 89,
        likes: 32,
        comments: 8
      }
    ];
  };

  const [articles, setArticles] = useState(loadInitialArticles());

  // 保存文章到localStorage
  useEffect(() => {
    try {
      localStorage.setItem('blog_articles', JSON.stringify(articles));
    } catch (error) {
      console.error('保存文章数据失败:', error);
    }
  }, [articles]);

  // 添加新文章
  const addArticle = (article) => {
    const newArticle = {
      ...article,
      id: Date.now(),
      date: new Date().toISOString().split('T')[0],
      views: 0,
      likes: 0,
      comments: 0
    };
    
    setArticles(prev => [newArticle, ...prev]);
    return newArticle;
  };

  // 更新文章
  const updateArticle = (id, updatedData) => {
    setArticles(prev => 
      prev.map(article => 
        article.id === parseInt(id) ? { ...article, ...updatedData } : article
      )
    );
  };

  // 删除文章
  const deleteArticle = (id) => {
    setArticles(prev => prev.filter(article => article.id !== parseInt(id)));
  };

  // 获取文章详情
  const getArticle = (id) => {
    return articles.find(article => article.id === parseInt(id));
  };

  // 获取所有文章
  const getAllArticles = () => {
    return articles;
  };

  return (
    <ArticleContext.Provider value={{
      articles,
      getAllArticles,
      getArticle,
      addArticle,
      updateArticle,
      deleteArticle
    }}>
      {children}
    </ArticleContext.Provider>
  );
};